import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/app.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';
import ErrorBoundary from './components/error-boundary/error-boundary';
import { createLogger } from './utilities/logger';

const log = createLogger("Global");

window.addEventListener("error", (event) => {
    log.error("Unhandled window error", {
        exception: event.error,
        source: event.filename,
        line: event.lineno,
        column: event.colno,
    });
});

window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    log.error("Unhandled promise rejection", {
        exception: reason,
    });
});

ReactDOM.render(
  <ErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </I18nextProvider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
